import React,{useEffect,useState} from 'react';
import { useParams } from 'react-router-dom';
import DeviceHeader from '../../../components/header/DeviceHeader';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import * as timeago from 'timeago.js';

import {
  collection,
  doc,
  onSnapshot,
  query,
  orderBy,
  limit
} from 'firebase/firestore';
import { db } from '../../../store/api/fbConfig';


import {
  Box,MenuItem,
  Button,
  Typography,
} from '@mui/material';

import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';

import { styled } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';


import axios from 'axios';
import { getAuth } from 'firebase/auth';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import Chip from '@mui/material/Chip';
import { baseURL } from '../../../store/api/Access'; // adjust to your baseURL
import { useOutletContext } from 'react-router-dom';



const useStyles = makeStyles()(() => ({
  colouredButton: {
    backgroundColor: "#19A78E",
    fontSize: "16px",
    color: "#fff",
    fontWeight: 700,
    textDecoration: "none",
    padding: "13px",
    borderRadius: "50px",
    "&:hover": {
      backgroundColor: "#374657",
    },
  },
  clearButton: {
    fontSize: "16px",
    color: "#374657",
    fontWeight: 700,
    textDecoration: "none",
  },
  Center: {
    textAlign: "center",
  },
  root: {},
  HeaderBox: {
    padding: "0 20px",
  },
  ToolBar: {
    padding: 0,
  },
  MenuItem: {
    color: "#8f9297",
    fontWeight: 700,
    padding: 0,
    margin: 0,
    marginRight: "10px",
    textAlign: "left",
    "&:hover": {
      background: "none",
      color: "#555",
    },
  },
  MenuItemSelected: {
    color: "#000",
  },
  LoadMoreBox: {
    marginTop: "20px",
    marginBottom: "60px",
    textAlign: "center",
  },
  LoadMoreButton: {
    padding: "10px 20px",
  },
}));

const Accordion = styled(MuiAccordion)({});
const AccordionSummary = styled(MuiAccordionSummary)({});
const AccordionDetails = styled(MuiAccordionDetails)({});

let timerOut = null;

const View = (props) => {
  const { userRole } = useOutletContext();

  const { classes } = useStyles();
  const [DeviceData, setDeviceData] = useState([]);
  const { id } = useParams();

  const [expanded, setExpanded] = useState(null);
  const [update, setUpdate] = useState(false);
  const [LimitCount, setLimitCount] = useState(100);
  const [confirmDeleteId, setConfirmDeleteId] = useState(null);
  const [addDialogOpen, setAddDialogOpen] = useState(false);
  const [addBody, setAddBody] = useState('');
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [addLoading, setAddLoading] = useState(false);
  
  const [exportDialogOpen, setExportDialogOpen] = useState(false);
const [exportCount, setExportCount] = useState(100);
const [exportFormat, setExportFormat] = useState("json");
const [exportLoading, setExportLoading] = useState(false);


useEffect(() => {
  const dataColRef = collection(doc(collection(db, 'Devices'), id), 'Data');
  const dataQuery = query(dataColRef, orderBy('dateCreated', 'desc'), limit(LimitCount));

  const unsubscribe = onSnapshot(dataQuery, (snapshot) => {
    const data = snapshot.docs.map((doc) => {
      const d = doc.data();
      let body = d.body;
      if (typeof body === 'string') {
        try {
          body = JSON.parse(body);
        } catch {}
      }
      return { id: doc.id, ...d, body };
    });
    setDeviceData(data);
  });

  return () => unsubscribe();
}, [id, LimitCount]);


const handleExportData = async () => {
  setExportLoading(true);
  try {
    const token = await getAuth().currentUser.getIdToken();

    const response = await axios.get(`${baseURL}/device/${id}/data/export`, {
      headers: { Authorization: token },
      params: {
        limit: Math.min(exportCount, 1000),
        format: exportFormat,
      },
    });

    const blob = new Blob(
      [exportFormat === "csv" ? response.data : JSON.stringify(response.data, null, 2)],
      { type: exportFormat === "csv" ? "text/csv" : "application/json" }
    );

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `device-${id}-export.${exportFormat}`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    setExportDialogOpen(false);
  } catch (error) {
    console.error("Export failed:", error);
    alert("Failed to export data");
  } finally {
    setExportLoading(false);
  }
};


  const handleDeleteData = async () => {
    setDeleteLoading(true);
    try {
      const token = await getAuth().currentUser.getIdToken();
      await axios.delete(`${baseURL}/device/${id}/data/${confirmDeleteId}`, {
        headers: { Authorization: token },
      });
      setConfirmDeleteId(null);
    } catch (err) {
      console.error('Delete failed:', err);
    } finally {
      setDeleteLoading(false);
    }
  };
  
  const handleAddData = async () => {
    setAddLoading(true);
    try {
      const token = await getAuth().currentUser.getIdToken();
      const parsed = JSON.parse(addBody);
      await axios.post(`${baseURL}/device/${id}/data`, parsed, {
        headers: { Authorization: token },
      });
      setAddDialogOpen(false);
      setAddBody('');
    } catch (e) {
      alert('Invalid JSON body');
    } finally {
      setAddLoading(false);
    }
  };
  
  
  /*
  useFirestoreConnect([
    {
      collection: 'Devices',
      doc: id,
      storeAs: 'DeviceData',
      limit: LimitCount,
      subcollections: [
        { collection: 'Data', orderBy: ['dateCreated', 'desc'] },
      ],
    },
  ]);*/

  const handleLoadMore = () => {
    setLimitCount(LimitCount + 10);
  };

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  if (timerOut) window.clearTimeout(timerOut);

  const handleTimerOut = () => {
    setUpdate(!update);
  };

  if (DeviceData && DeviceData[0]) {
    const secondsAgo = new Date().getTime() / 1000 - DeviceData[0].dateCreated?.seconds;
    if (secondsAgo <= 60)
      timerOut = setTimeout(handleTimerOut, 1000);
    else if (secondsAgo <= 3600)
      timerOut = setTimeout(handleTimerOut, (60 - (secondsAgo % 60)) * 1000);
    else if (secondsAgo <= 86400)
      timerOut = setTimeout(handleTimerOut, (3600 - (secondsAgo % 3600)) * 1000);
    else
      timerOut = setTimeout(handleTimerOut, 86400000);
  }

  
  function beautifyBody(body) {
    try {
      if (typeof body === 'string') {
        body = JSON.parse(body);
      }
  
      function format(value, indent = 2, level = 0) {
        const pad = ' '.repeat(indent * level);
        const padInner = ' '.repeat(indent * (level + 1));
  
        if (Array.isArray(value)) {
          // 1D array of primitives
          if (value.every(item => typeof item !== 'object')) {
            return `[${value.join(', ')}]`;
          }
  
          // 2D array of primitives
          if (
            value.every(
              row => Array.isArray(row) && row.every(col => typeof col !== 'object')
            )
          ) {
            const rows = value.map(
              row => `${padInner}[${row.join(', ')}]`
            );
            return `[\n${rows.join(',\n')}\n${pad}]`;
          }
  
          // fallback
          return JSON.stringify(value, null, indent);
        }
  
        if (typeof value === 'object' && value !== null) {
          const entries = Object.entries(value).map(([key, val]) => {
            return `${padInner}"${key}": ${format(val, indent, level + 1)}`;
          });
          return `{\n${entries.join(',\n')}\n${pad}}`;
        }
  
        return JSON.stringify(value);
      }
  
      return format(body);
    } catch (e) {
      return body;
    }
  }
  

  return (
    <div className={classes.root}>


      <Box textAlign="center" mt={3}>

      { userRole === 'admin' || userRole === 'editor' || userRole === 'owner' ? 
        <Button variant="contained" color="primary" onClick={() => setAddDialogOpen(true)}>
          Add Data
        </Button>
        :null}

        <Button variant="outlined" color="secondary" onClick={() => setExportDialogOpen(true)} sx={{ ml: 2 }}>
  Export Data
</Button>

      </Box>


      {DeviceData && DeviceData.map((row) => {
        const dateCreatedTimeAgo = row.dateCreated
          ? timeago.format(row.dateCreated.seconds * 1000, 'time')
          : '';
        const dateCreated = row.dateCreated
          ? new Date(row.dateCreated.seconds * 1000)
          : '';

        return (
          <Accordion
            square
            expanded={expanded === row.id}
            onChange={handleChange(row.id)}
            key={row.id}
          >
            <AccordionSummary>
  <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
    <Typography>
      {dateCreatedTimeAgo} — {dateCreated.toLocaleString("en-AU")}
    </Typography>
    <Box display="flex" alignItems="center" gap={1}>
      {row.user && <Chip label="USER" color="primary" size="small" />}
      <IconButton size="small" onClick={(e) => {
        e.stopPropagation();
        setConfirmDeleteId(row.id);
      }}>
        <DeleteIcon />
      </IconButton>
    </Box>
  </Box>
</AccordionSummary>

            <AccordionDetails>
              <Box>
                <Typography>Body</Typography>
                <Typography>
                  <pre id="json">{beautifyBody(row.body)}</pre>
                </Typography>
                {/* 
                <Typography>Headers</Typography>
                <List>
                  {row.headers && Object.entries(row.headers).map(([key, value]) => (
                    <ListItem key={key}>
                      <ListItemText primary={key} secondary={value} />
                    </ListItem>
                  ))}
                </List>
                */}
              </Box>
            </AccordionDetails>
          </Accordion>
        );
      })}

      <Box onClick={handleLoadMore} className={classes.LoadMoreBox}>
        <Button className={classes.LoadMoreButton}>Load more</Button>
      </Box>


      <Dialog open={Boolean(confirmDeleteId)} onClose={() => setConfirmDeleteId(null)}>
  <DialogTitle>Delete Data Entry</DialogTitle>
  <DialogContent>
    Are you sure you want to delete this data entry?
  </DialogContent>
  <DialogActions>
  <Button onClick={() => setConfirmDeleteId(null)} disabled={deleteLoading}>Cancel</Button>
  <Button
    color="secondary"
    onClick={handleDeleteData}
    variant="contained"
    disabled={deleteLoading}
  >
    {deleteLoading ? 'Deleting...' : 'Delete'}
  </Button>
</DialogActions>

</Dialog>

<Dialog open={addDialogOpen} onClose={() => setAddDialogOpen(false)} maxWidth="sm" fullWidth>
  <DialogTitle>Add Device Data</DialogTitle>
  <DialogContent>
    <TextField
      label="Body (JSON)"
      multiline
      rows={6}
      fullWidth
      value={addBody}
      onChange={(e) => setAddBody(e.target.value)}
      placeholder='{"lat": -33.75, "lon": 151.29, "spd": 0}'
    />
  </DialogContent>
  <DialogActions>
  <Button onClick={() => setAddDialogOpen(false)} disabled={addLoading}>Cancel</Button>
  <Button
    variant="contained"
    onClick={handleAddData}
    disabled={addLoading}
  >
    {addLoading ? 'Submitting...' : 'Submit'}
  </Button>
</DialogActions>

</Dialog>

<Dialog open={exportDialogOpen} onClose={() => setExportDialogOpen(false)} maxWidth="xs" fullWidth>
  <DialogTitle>Export Data</DialogTitle>
  <DialogContent>
    <Box mt={2}>
      <TextField
        label="Number of Records (max 1000)"
        type="number"
        fullWidth
        value={exportCount}
        onChange={(e) => setExportCount(Number(e.target.value))}
        inputProps={{ min: 1, max: 1000 }}
        margin="dense"
      />
      <TextField
        label="Format"
        select
        fullWidth
        value={exportFormat}
        onChange={(e) => setExportFormat(e.target.value)}
        margin="dense"
      >
        <MenuItem value="json">JSON</MenuItem>
        <MenuItem value="csv">CSV</MenuItem>
      </TextField>
    </Box>
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setExportDialogOpen(false)} disabled={exportLoading}>
      Cancel
    </Button>
    <Button variant="contained" onClick={handleExportData} disabled={exportLoading}>
      {exportLoading ? "Exporting..." : "Export"}
    </Button>
  </DialogActions>
</Dialog>

    </div>
  );
};


/*
const mapStateToProps = (state) => {
  let DevicesDetails = null;
  let DeviceData = null;

  if (state.firestore.ordered.DevicesDetails)
    DevicesDetails = state.firestore.ordered.DevicesDetails[0];

  if (state.firestore.ordered.DeviceData)
    DeviceData = state.firestore.ordered.DeviceData;

  return {
    DevicesDetails,
    DeviceData,
  };
};*/

export default /*connect(mapStateToProps)*/(View);
